import { computed as a } from "vue";
import { useLocale as Y } from "./index597.js";
const t = ({
  unlinkPanels: u,
  leftDate: e,
  rightDate: r
}) => {
  const { t: v } = Y(), l = () => {
    e.value = e.value.subtract(1, "year"), u.value || (r.value = r.value.subtract(1, "year"));
  }, o = () => {
    u.value || (e.value = e.value.add(1, "year")), r.value = r.value.add(1, "year");
  }, c = () => {
    e.value = e.value.add(1, "year");
  }, y = () => {
    r.value = r.value.subtract(1, "year");
  }, n = a(() => `${e.value.year()} ${v("el.datepicker.year")}`), s = a(() => `${r.value.year()} ${v("el.datepicker.year")}`), d = a(() => e.value.year()), p = a(() => r.value.year() === e.value.year() ? e.value.year() + 1 : r.value.year());
  return {
    leftPrevYear: l,
    rightNextYear: o,
    leftNextYear: c,
    rightPrevYear: y,
    leftLabel: n,
    rightLabel: s,
    leftYear: d,
    rightYear: p
  };
};
export {
  t as useMonthRangeHeader
};
